import React, { useEffect } from "react";
import { toast } from "sonner";
import { BOOKING_URL } from "@/lib/site-config";

export default function BookSection({ id = "book", headline, eyebrow = "Next steps are simple", lede, url = BOOKING_URL }) {
  useEffect(() => {
    const sid = "calendly-widget-script";
    if (!document.getElementById(sid)) {
      const s = document.createElement("script");
      s.id = sid;
      s.src = "https://assets.calendly.com/assets/external/widget.js";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <section id={id} className="py-24 lg:py-32 relative overflow-hidden editorial">
      <div className="absolute -top-20 -left-32 w-[500px] h-[500px] rounded-full bg-[var(--terracotta)]/10 blur-3xl pointer-events-none" />
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase tracking-[0.3em] text-[var(--terracotta)] font-medium">
            {eyebrow}
          </div>
          <h2
            className="font-serif text-4xl lg:text-6xl text-[var(--navy)] mt-5 leading-[1.02]"
            data-testid="book-headline"
          >
            {headline || (
              <>
                Book your eligibility
                <br />
                <em>&amp; next-steps call.</em>
              </>
            )}
          </h2>
          <p className="mt-6 text-[var(--ink-soft)] text-lg">
            {lede ||
              "A relaxed, honest conversation. We'll see if NLV Approved is the right fit and map out what your next 6–12 months could look like."}
          </p>
        </div>

        <div
          className="mt-14 rounded-[2rem] overflow-hidden bg-white shadow-2xl border border-black/5"
          data-testid="calendly-embed"
        >
          <div
            className="calendly-inline-widget"
            data-url={`${url}?hide_event_type_details=0&hide_gdpr_banner=1&primary_color=b8472d`}
            style={{ minWidth: "320px", height: "780px" }}
          />
        </div>

        <div className="mt-10 text-center">
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={() => toast.success("Opening Calendly in a new tab")}
            className="text-sm text-[var(--terracotta)] underline underline-offset-4 hover:text-[var(--terracotta-deep)]"
            data-testid="calendly-fallback-link"
          >
            Or open the booking page in a new tab →
          </a>
        </div>
      </div>
    </section>
  );
}
